import {LoadingService, MessagesModal, MessageModalMessageList, RemoteExceptionHandler} from "front-end-web-commons/app/index.d.ts";
import {
    InstanceTypeByRemoteServicesConfigParams,
    InstanceTypeUpdateData,
    RemoteRoutingService
} from "./remoteRoutingService";
import {remoteRoutingModule} from "./remoteRoutingModule";

const arrays = require("front-end-web-commons/app/arrays/arrays")

class NlgRemoteRoutingConfiguration {

    private remoteRoutingTypeConfigs: InstanceTypeByRemoteServicesConfigParams[];

    constructor(private loadingService: LoadingService,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private messagesModal: MessagesModal,
                private remoteRoutingService: RemoteRoutingService) {
        this.loadRemoteTypesConfigurations();
    }

    loadRemoteTypesConfigurations() {
        this.loadingService(this.remoteRoutingService.getRemoteTypesConfigurations())
            .catch(this.remoteExceptionHandler())
            .then((configs: InstanceTypeByRemoteServicesConfigParams[]) => {
                let shouldCreateNewConfig = !configs || !configs.length || arrays.filter(configs, (config) => {
                    return config.instanceTypeUpdateData && config.instanceTypeUpdateData.length > 0;
                }).length === 0;

                if(shouldCreateNewConfig){
                    this.messagesModal.cancellable("dialog.proceed?",
                        "configParams.orchestratedRouting.remote.routing.create.config.type"
                    ).then( () => {
                        this.createRemoteTypesConfigurations();
                    });
                }else{
                    return this.remoteRoutingTypeConfigs = configs
                }
            });
    }

    createRemoteTypesConfigurations() {
        this.loadingService(this.remoteRoutingService.createRemoteTypesConfigurations())
            .catch(this.remoteExceptionHandler())
            .then((configs: InstanceTypeByRemoteServicesConfigParams[]) => {
                return this.remoteRoutingTypeConfigs = configs;
            });
    }

    getMappedMachineTypes(){
        return this.remoteRoutingService.getMappedMachineTypes();
    }

    testParallelism(instanceUpdateDataByUrl: string, instanceUpdateData: InstanceTypeUpdateData) {
        return this.loadingService(this.remoteRoutingService.testRoutingParallelism({
            orchestratorUrl: instanceUpdateDataByUrl,
            instanceTypeUpdateData: instanceUpdateData
        }))
            .catch(this.remoteExceptionHandler())
            .then((messages: MessageModalMessageList) => this.messagesModal("dialog.result", messages))
    }

    save() {
        return this.loadingService(this.remoteRoutingService.updateRemoteTypeConfigurations(this.remoteRoutingTypeConfigs))
            .catch(this.remoteExceptionHandler())
            .then(() => this.messagesModal("dialog.success", "config.params.save.success"))
    }

    getRemoteTypesConfigurations() {
        return this.loadingService(this.remoteRoutingService.getRemoteTypesConfigurations())
            .catch(this.remoteExceptionHandler())
            .then((configs: InstanceTypeByRemoteServicesConfigParams[]) => {
                return configs;
            })
    }
}

remoteRoutingModule.directive("nlgRemoteRoutingConfiguration", [function () {
    return {
        restrict: "E",
        templateUrl: require("link!./nlgRemoteRoutingConfiguration.html"),
        scope: {},
        controllerAs: "ctrl",
        controller: NlgRemoteRoutingConfiguration
    }
}])